/* eslint-disable no-console */
/* eslint-disable max-len */
/* eslint-disable indent */
/* eslint-disable no-unneeded-ternary */
/* eslint-disable react/jsx-boolean-value */
/* eslint-disable no-console */

import React, { useState, useEffect, useCallback, useMemo } from 'react';
import $ from 'jquery';
import pako from 'pako';
import * as XLSX from 'xlsx';
import { Backdrop, CircularProgress, Box, Button, IconButton, lighten, Tooltip } from '@mui/material';
import { notification } from 'antd';
import { MaterialReactTable } from 'material-react-table';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import Notification from '../../shared/notification-modal';
import { defaultModalOptions } from '../../shared/constantVariable';
import { addAdminData, updateAdminData, deleteAdminData } from '../../shared/api/url-helper';

import './admin.scss';
/* eslint-disable */
let handleAddRow;
let globalRow = 1;
/* eslint-enable */

const AdminTable = (props) => {
  const { currentRowData, currentColumns, currentTableName,
    currentTablePK, dbTransactionDetails, setDbTransactionDetails,
    isLoading, handleCallFromChild } = props;
  const [rowData, setRowData] = useState(currentRowData);
  const [columnDefs, setColumnDefs] = useState(currentColumns);
  const [modalOption, setModalOption] = useState(defaultModalOptions);
  const [api, contextHolder] = notification.useNotification();
  const placement = 'topRight';
  const [, setAddrow] = React.useState('');
  const [fetchLoading, setFetchLoading] = useState(false);
  const hdata = [];
  const tag = [];
  const disabled = [];
  const datatype = [];
  const coloumnName = ['Elements', 'IP_Bvalue'];
  const booleanTrue = true;
  const booleanFalse = false;
  const setTableRowandCol = () => {
    setRowData(currentRowData);
    setColumnDefs(currentColumns);

    for (let i = 0; i < columnDefs.length; i += 1) {
      hdata[i] = columnDefs[i].field;
      tag[i] = columnDefs[i].field;
      disabled[i] = '';
      datatype[i] = '';
    }
  };

  useEffect(() => {
    // To merge first 2 header columns
    $('.admin-ag-grid-container #hcell_0').attr('colspan', 2);
    $('.admin-ag-grid-container #hcell_1').css('display', 'none');
    setTableRowandCol();
  }, [currentColumns, currentRowData, rowData]);

  useEffect(() => {
    $(`.admin-ag-grid-container .row_${globalRow + 1} #input_num${globalRow + 1}_1`).removeClass('admin-editok-icon');
    $(`.admin-ag-grid-container .row_${globalRow + 1} #input_num${globalRow + 1}_1`).addClass('admin-edit-icon');
  }, [currentRowData]);

  // function to add an empty row at the top of the table
  handleAddRow = useCallback(() => {

    const firstRow = currentRowData[0];
    const objKeys = Object.keys(firstRow);
    const obj = {};

    objKeys.forEach((item) => {
      obj[item] = '';
    });

    const newRowData = rowData;
    newRowData.unshift(obj);
    setRowData([]);
    setAddrow('addRow');

  });

  const handleSaveRow = async ({ exitEditingMode, row, values }) => {
    // if using flat data and simple accessorKeys/ids, you can just do a simple assignment here.
    // do update opeartion
    rowData[row.index] = values;
    // send/receive api updates here
    const data = values;
    const editRow = data;

    // for Element table
    if (currentTableName === 'Elements') {
      if (editRow.nHelpContext === null) {
        editRow.nHelpContext = 0;
      }
    }
    const editRowObj = {
      operation_type: 'update',
      table_name: currentTableName,
      primary_key: currentTablePK,
      primary_key_value: editRow[currentTablePK],
      update_values: editRow
    };

    setFetchLoading(true);
    updateAdminData(JSON.stringify(editRowObj))
      .then((upRes) => {
        setFetchLoading(false);
        let res = JSON.parse(upRes.data);
        const compressedData = JSON.parse(upRes.data).compressed_data;
        // Convert the compressed data from Base64 to a Uint8Array
        const compressedDataUint8Array = Uint8Array.from(atob(compressedData), c => c.charCodeAt(0));
        // Decompress the data using pako
        const decompressedData = pako.inflate(compressedDataUint8Array, { to: 'string' });
        res = JSON.parse(decompressedData);

        if (res.status.includes('invalid input syntax')) {
          api.error({
            message: 'Invalid input syntax',
            placement,
            closable: false,
            icon: null
          });
        }
        else {
          const tempDB = dbTransactionDetails; // replace curr table data with updated row table
          tempDB.db_tables_data[currentTableName] = res[currentTableName];
          setDbTransactionDetails(tempDB);
          setRowData([...rowData]);
          api.success({
            message: 'Data update successfull',
            placement,
            closable: false,
            icon: null
          });
        }
      })
      .catch(() => {
        setFetchLoading(false);
        api.error({
          message: 'Data update Failed',
          placement,
          closable: false,
          icon: null
        });
      });
    exitEditingMode(); // required to exit editing mode
  };
  const handleSaveRowCreate = async ({ values, table }) => {
    // if using flat data and simple accessorKeys/ids, you can just do a simple assignment here.
    // do update opeartion
    // send/receive api updates here
    const data = values;
    const editRow = data;
    // for Element table
    if (currentTableName === 'Elements') {
      if (editRow.nHelpContext === null) {
        editRow.nHelpContext = 0;
      }
    }
    const addRowObj = {
      operation_type: 'add',
      sub_operation_type: 'add_rows',
      table_name: currentTableName,
      values: editRow
    };

    setFetchLoading(true);
    addAdminData(JSON.stringify(addRowObj))
      .then((upRes) => {
        setFetchLoading(false);
        let res = JSON.parse(upRes.data);
        const compressedData = JSON.parse(upRes.data).compressed_data;
        // Convert the compressed data from Base64 to a Uint8Array
        const compressedDataUint8Array = Uint8Array.from(atob(compressedData), c => c.charCodeAt(0));
        // Decompress the data using pako
        const decompressedData = pako.inflate(compressedDataUint8Array, { to: 'string' });
        res = JSON.parse(decompressedData);
        if (res.status.includes('Data adding failed')) {
          setFetchLoading(false);
          api.error({
            message: 'Invalid input syntax',
            placement,
            closable: false,
            icon: null
          });
        } else {
          const tempDB = dbTransactionDetails; // replace curr table data with added row one
          tempDB.db_tables_data[currentTableName] = res[currentTableName];
          setDbTransactionDetails(tempDB);
          handleCallFromChild(currentTableName);
          setRowData([...rowData]);
          api.success({
            message: 'Data added successfully',
            placement,
            closable: false,
            icon: null
          });
          $('.admin-ag-grid-container .row_1 #input_num1_1').removeClass('admin-editok-icon');
          $('.admin-ag-grid-container .row_1 #input_num1_1').addClass('admin-edit-icon');
        }
      })
      .catch(() => {
        setFetchLoading(false);
        api.error({
          message: 'Data added Failed',
          placement,
          closable: false,
          icon: null
        });
        $('.admin-ag-grid-container .row_1 #input_num1_1').removeClass('admin-editok-icon');
        $('.admin-ag-grid-container .row_1 #input_num1_1').addClass('admin-edit-icon');
      });
    table.setCreatingRow(null); // required to exit editing mode
  };
  const cancelDeleteRowOperation = () => {
    setModalOption(defaultModalOptions);
  };
  const doDeleteRowOperation = async (row) => {
    setModalOption(defaultModalOptions);
    const data = row.original;
    const selectedRow = data;
    const deleteObj = {
      operation_type: 'delete',
      sub_operation_type: 'delete_rows',
      table_name: currentTableName,
      primary_key: currentTablePK,
      row_ids: { '1': selectedRow[currentTablePK] }
    };

    setFetchLoading(true);
    deleteAdminData(JSON.stringify(deleteObj)).then((delRes) => {
      setFetchLoading(false);
      let res = JSON.parse(delRes.data);
      const compressedData = JSON.parse(delRes.data).compressed_data;
      // Convert the compressed data from Base64 to a Uint8Array
      const compressedDataUint8Array = Uint8Array.from(atob(compressedData), c => c.charCodeAt(0));
      // Decompress the data using pako
      const decompressedData = pako.inflate(compressedDataUint8Array, { to: 'string' });
      res = JSON.parse(decompressedData);
      rowData.splice(row.index, 1); // assuming simple data table
      setRowData([...rowData]);
      const tempDB = dbTransactionDetails;  // replace [] with updated table
      tempDB.db_tables_data[currentTableName] = res[currentTableName];
      setDbTransactionDetails(tempDB);
      setModalOption(defaultModalOptions);
      api.success({
        message: `${res.status}`,
        placement,
        closable: false,
        icon: null
      });
      setRowData(res[currentTableName]);
      setFetchLoading(false);
    }).catch(() => {
      setFetchLoading(false);
      api.error({
        message: 'Data deletion Failed',
        placement,
        closable: false,
        icon: null
      });
    });
  };
  const handleDeleteRowOperation = (row) => {
    setModalOption({
      ...defaultModalOptions,
      visible: true,
      title: 'Warning',
      message: 'Are you sure you want to delete?',
      yesOrNo: true,
      onYes: () => doDeleteRowOperation(row),
      onNo: () => cancelDeleteRowOperation()
    });
  };
  const columns = useMemo(() => {
    return columnDefs.map(item => ({
      accessorKey: item.tag,
      header: item.hdata,
      size: 150,
      muiTableHeadCellProps: {
        align: 'center',
      },
      muiTableBodyCellProps: {
        align: 'center',
      },
      muiTableFooterCellProps: {
        align: 'center',
      },
    }));
  }, [columnDefs]);

  const downloadTableAsDisplayed_old = (table, currentTableName) => {
    // Get all rows before pagination
    const allRows = table.getPrePaginationRowModel().rows.map(row => row.original);

    // Get the column order as displayed, excluding 'mrt-row-actions'
    const displayedColumns = table.getVisibleLeafColumns()
      .map(column => column.id)
      .filter(columnId => columnId !== 'mrt-row-actions')
      .filter(columnId => columnId !== 'mrt-row-spacer');

    // Convert to CSV using displayed column order
    const csvRows = [
      displayedColumns.join(','), // Header row
      ...allRows.map(row => displayedColumns.map(column => row[column]).join(',')) // Data rows
    ];
    const csvString = csvRows.join('\n');

    // Create blob and download
    const blob = new Blob([csvString], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);
    link.setAttribute('href', url);
    link.setAttribute('download', `${currentTableName}.csv`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const downloadTableAsDisplayed = (table, currentTableName) => {
    // Get all rows before pagination
    const allRows = table.getPrePaginationRowModel().rows.map(row => row.original);

    // Get the column order as displayed, excluding 'mrt-row-actions'
    const displayedColumns = table.getVisibleLeafColumns()
      .map(column => column.id)
      .filter(columnId => columnId !== 'mrt-row-actions')
      .filter(columnId => columnId !== 'mrt-row-spacer');

    // Prepare data for Excel
    const excelData = [
      displayedColumns, // Header row
      ...allRows.map(row => displayedColumns.map(column => row[column])) // Data rows
    ];

    // Create a workbook and add the data
    const workbook = XLSX.utils.book_new();
    const worksheet = XLSX.utils.aoa_to_sheet(excelData);
    XLSX.utils.book_append_sheet(workbook, worksheet, currentTableName);

    // Generate Excel file and trigger download
    XLSX.writeFile(workbook, `${currentTableName}.xlsx`);
  };

  return (
    <div>
      {contextHolder}
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1000 }}
        style={{
          background: '#d9dbde5c',
        }}
        open={fetchLoading}
      >
        <CircularProgress color="inherit" style={{ color: '#4b93f4' }} />
      </Backdrop>
      <Notification
        options={modalOption}
        handleClose={() => setModalOption(defaultModalOptions)}
      />
      <div>
        {isLoading &&
          <center>
            <CircularProgress color="inherit" style={{ color: '#4b93f4' }} />
          </center>
        }
      </div>
      {!isLoading &&
        <div id='abhishek' className='ag-theme-alpine admin-ag-grid-container UIGrid' style={{ overflow: 'hidden' }}>
          <MaterialReactTable
            columns={columns}
            data={rowData}
            enableStickyHeader  // sticky header
            enableColumnFilterModes
            enableCellActions={booleanTrue}
            enablePagination={(coloumnName).includes(currentTableName) ? booleanTrue : booleanFalse}
            editDisplayMode='row' // ('modal', 'cell', 'table', and 'custom' are also available)
            enableEditing={booleanTrue}
            enableColumnPinning={booleanTrue}
            enableRowActions={booleanTrue}
            muiTableContainerProps={{ sx: { maxHeight: (coloumnName).includes(currentTableName) ? '65vh' : '72vh' } }}
            enablePinning
            layoutMode='grid-no-grow'
            initialState={
              { density: 'compact', pagination: { pageSize: 15, pageIndex: 0 }, columnPinning: { left: ['mrt-row-actions'] } }
            }
            enableColumnResizing={booleanTrue}
            columnResizeMode='onEnd' // instead of the default "onChange" mode
            createDisplayMode='row'
            onCreatingRowSave={handleSaveRowCreate}
            onEditingRowSave={handleSaveRow}
            renderRowActions={({ row, table }) => (
              <Box sx={{ display: 'flex', gap: '1rem' }}>
                <Tooltip title="Edit">
                  <IconButton onClick={() => table.setEditingRow(row)}>
                    <EditIcon />
                  </IconButton>
                </Tooltip>
                <Tooltip title="Delete">
                  <IconButton color="error" onClick={() => {
                    handleDeleteRowOperation(row);
                  }
                  }>
                    <DeleteIcon />
                  </IconButton>
                </Tooltip>
              </Box>
            )}
            // renderTopToolbarCustomActions={({ table }) => (
            //   <Button
            //     variant="contained"
            //     id='buttonRenderTopToolbar'
            //     className=''
            //     onClick={() => {
            //       table.setCreatingRow(true); // simplest way to open the create row modal with no default values
            //     }}
            //   >
            //     Add Row
            //   </Button>
            // )}

            renderTopToolbarCustomActions={({ table }) => (
              <Box sx={{ display: 'flex', gap: '1rem' }}>
                <Button
                  variant="contained"
                  id='buttonRenderTopToolbar'
                  onClick={() => table.setCreatingRow(true)}
                >
                  Add Row
                </Button>
                <Button
                  variant="contained"
                  id='buttonRenderTopToolbar'
                  onClick={() => downloadTableAsDisplayed(table, currentTableName)}
                >
                  Download Table
                </Button>
              </Box>
            )}
            enableColumnActions={false} // hide each column 3 vertical dot
            enableTopToolbar={booleanTrue} // hide top toolbar
            muiTablePaperProps={
              {
                elevation: 0,
                sx: {
                  borderRadius: '0'
                },
              }
            }
            muiTableBodyProps={{
              sx: () => ({
                '& tr:nth-of-type(odd):not([data-selected="true"]):not([data-pinned="true"]) > td':
                {
                  backgroundColor: lighten('#0000000b', 0.1),
                },
                '& tr:nth-of-type(odd):not([data-selected="true"]):not([data-pinned="true"]):hover > td':
                {
                  backgroundColor: lighten('#95DEE8', 0.1),
                },
                '& tr:nth-of-type(even):not([data-selected="true"]):not([data-pinned="true"]) > td': {},
                '& tr:nth-of-type(even):not([data-selected="true"]):not([data-pinned="true"]):hover > td':
                {
                  backgroundColor: lighten('#95DEE8', 0.1),
                },
              })
            }}
            enableBottomToolbar={(coloumnName).includes(currentTableName) ? booleanTrue : booleanFalse} // hide bottom toolbar
          />
        </div>
      }
    </div>
  );
};
export default AdminTable;
export { handleAddRow };